import type { IServiceClient } from 'src/interfaces/serviceClient';
import type {
    TServiceClientFormValues,
    TServiceClientFormVehicle,
} from './types';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';

type VehicleItem = { _id?: string; vehicle: IServiceClient['service']['vehicles'][0]['vehicle'] };

function mapVehicles(
    raw: IServiceClient['service']['vehicles'] | undefined
): TServiceClientFormVehicle[] {
    const items: VehicleItem[] = Array.isArray(raw) ? raw : raw ? [raw] : [];
    return items.map((item) => {
        const v = item?.vehicle;
        const makeObj = typeof v?.make === 'object' ? v.make : null;
        return {
            make: makeObj?._id ?? '',
            makeName: makeObj?.name ?? '',
            vehicleId: item?._id ?? v?._id ?? '',
            model: v?.model ?? '',
            modelType: v?.modelType ?? '',
            year: v?.year ?? '',
            vin: v?.vin ?? '',
            kilometers: v?.kilometers ?? 0,
        };
    });
}

/**
 * Maps an IServiceClient (API shape) to Partial<TServiceClientFormValues> (form shape).
 * Normalizes source/store from string | object to string for the form.
 */
export function mapServiceClientToFormValues(
    client: IServiceClient | null
): Partial<TServiceClientFormValues> {
    if (!client) return {};
    return {
        name: client.name ?? '',
        email: client.email ?? '',
        phone: client.phone ?? '',
        countryCode: client.countryCode,
        source: getDocumentId(client?.source) ?? '',
        store: getDocumentId(client?.store) ?? '',
        service: {
            vehicles: mapVehicles(client.service?.vehicles),
        },
    };
}
